module.exports = __webpack_public_path__ + "img/db-khoan-no-tra.53773907.svg";